var _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_91_53001",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6894 18.3919C21.131 16.659 21.998 14.4311 21.998 12.0007C21.998 6.47788 17.5209 2.00073 11.998 2.00073C6.4752 2.00073 1.99805 6.47788 1.99805 12.0007C1.99805 17.5236 6.4752 22.0007 11.998 22.0007C14.1037 22.0007 16.0574 21.3499 17.6689 20.2385C17.6861 20.2475 17.7042 20.2555 17.7233 20.2623L19.9382 21.0467C20.2554 21.159 20.5611 20.8533 20.4488 20.5361L19.6894 18.3919Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.6894 18.3919L18.9207 17.7524L18.5569 18.1897L18.7468 18.7258L19.6894 18.3919ZM17.6689 20.2385L18.1349 19.3537L17.5993 19.0716L17.1011 19.4153L17.6689 20.2385ZM17.7233 20.2623L18.0571 19.3196L18.0571 19.3196L17.7233 20.2623ZM19.9382 21.0467L20.272 20.104H20.272L19.9382 21.0467ZM20.4488 20.5361L19.5062 20.8699V20.8699L20.4488 20.5361ZM20.998 12.0007C20.998 14.1889 20.2184 16.1924 18.9207 17.7524L20.4582 19.0315C22.0437 17.1256 22.998 14.6733 22.998 12.0007H20.998ZM11.998 3.00073C16.9686 3.00073 20.998 7.03017 20.998 12.0007H22.998C22.998 5.9256 18.0732 1.00073 11.998 1.00073V3.00073ZM2.99805 12.0007C2.99805 7.03017 7.02748 3.00073 11.998 3.00073V1.00073C5.92291 1.00073 0.998047 5.9256 0.998047 12.0007H2.99805ZM11.998 21.0007C7.02748 21.0007 2.99805 16.9713 2.99805 12.0007H0.998047C0.998047 18.0759 5.92291 23.0007 11.998 23.0007V21.0007ZM17.1011 19.4153C15.6512 20.4153 13.8945 21.0007 11.998 21.0007V23.0007C14.3129 23.0007 16.4635 22.2846 18.2366 21.0617L17.1011 19.4153ZM18.0571 19.3196C18.0834 19.3289 18.1094 19.3403 18.1349 19.3537L17.2028 21.1233C17.2627 21.1548 17.325 21.1821 17.3895 21.2049L18.0571 19.3196ZM20.272 20.104L18.0571 19.3196L17.3895 21.2049L19.6044 21.9893L20.272 20.104ZM19.5062 20.8699C19.3376 20.3941 19.7962 19.9355 20.272 20.104L19.6044 21.9893C20.7146 22.3825 21.7846 21.3125 21.3914 20.2023L19.5062 20.8699ZM18.7468 18.7258L19.5062 20.8699L21.3914 20.2023L20.6321 18.0581L18.7468 18.7258Z",
    fill: "#666666",
    style: {
      fill: "#666666",
      fill: "color(display-p3 0.4000 0.4000 0.4000)",
      fillOpacity: 1
    },
    mask: "url(#path-1-inside-1_91_53001)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.00195,
    cy: 12.0007,
    r: 1.4,
    fill: "#666666",
    stroke: "#979797",
    style: {
      fill: "#666666",
      fill: "color(display-p3 0.4000 0.4000 0.4000)",
      fillOpacity: 1,
      stroke: "#979797",
      stroke: "color(display-p3 0.5922 0.5922 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 1.4,
    fill: "#666666",
    stroke: "#979797",
    style: {
      fill: "#666666",
      fill: "color(display-p3 0.4000 0.4000 0.4000)",
      fillOpacity: 1,
      stroke: "#979797",
      stroke: "color(display-p3 0.5922 0.5922 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.998,
    cy: 12.0007,
    r: 1.4,
    fill: "#666666",
    stroke: "#979797",
    style: {
      fill: "#666666",
      fill: "color(display-p3 0.4000 0.4000 0.4000)",
      fillOpacity: 1,
      stroke: "#979797",
      stroke: "color(display-p3 0.5922 0.5922 0.5922)",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.c501610051f9a714930606c1503047f6.svg";
export { ForwardRef as ReactComponent };